export default "__VITE_ASSET__89a5ac36__"